import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'; // ES6
import { Select } from 'antd';

import { seleccioEstacio } from '../../actions/index';

const Option = Select.Option;

/**
 * Selector per seleccionar una estació dins del llistat de totes les possibles
 * per l'usuari.
 *
 */
class EstacioSelector extends Component {

    constructor(props) {
        super(props);

        this.onClickEstacio = this.onClickEstacio.bind(this);
    }

    onClickEstacio(event) {
        const llistatEstacions = this.props.totesEstacions;
        const codiEstacioSeleccionada = this.props.codiEstacioSeleccionada;

        let codiNovaEstacioSeleccionada = event;
        var estacioSeleccionada;

        if (codiEstacioSeleccionada !== codiNovaEstacioSeleccionada) {
            estacioSeleccionada = llistatEstacions.find((estacio) => {
                return (estacio.codi === codiNovaEstacioSeleccionada);
            });

            if (estacioSeleccionada){
                this.props.seleccioEstacio(estacioSeleccionada.codi);
            }
        }
    }

    condicionsFiltratge(input, option) {
        return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }

    renderEstacio(estacions) {
        return estacions.map((estacio, index) => {
            return <Option key={estacio.codi + '-' + index} value={estacio.codi}>{estacio.nom}</Option>;
        });
    }

    render() {
        const llistatEstacions = this.props.totesEstacions;
        const codiEstacioSeleccionada = this.props.codiEstacioSeleccionada;

        if (llistatEstacions && codiEstacioSeleccionada) {
            if (teMesDunaEstacio(llistatEstacions)) {
                return (
                    <Select
                        style={{width: '100%'}}
                        showSearch
                        defaultValue={codiEstacioSeleccionada}
                        placeholder="Seleccioni una estació"
                        onChange={this.onClickEstacio}
                        notFoundContent="Estació no trobada"
                        optionFilterProp="children"
                        filterOption={this.condicionsFiltratge}>

                        {this.renderEstacio(llistatEstacions)}
                    </Select>
                );
            } else if (teUnaEstacio(llistatEstacions)) {
                const estacioUsuari = llistatEstacions[0];
                return <div className='observacio-selector-estacio-nom'>{estacioUsuari.nom}</div>;
            }
        }
        return <div className='observacio-selector-estacio-no-assignada'>{'Sense estacions assignades'}</div>;
    }
}

function teMesDunaEstacio(llistatEstacions) {
    return (llistatEstacions.length > 1);
}

function teUnaEstacio(llistatEstacions) {
    return (llistatEstacions.length === 1);
}

EstacioSelector.propTypes = {
    totesEstacions: PropTypes.array,
    codiEstacioSeleccionada: PropTypes.string,
    seleccioEstacio: PropTypes.func
};

const mapStateToProps = (state) => ({
    totesEstacions: state.observacio.estacio.totes,
    codiEstacioSeleccionada: state.observacio.estacio.codiSeleccionada
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        seleccioEstacio
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(EstacioSelector);



// WEBPACK FOOTER //
// ./src/components/observacio/estacioSelector.js